import { createContext } from 'react';
import { PartnerType } from '../Partners';
import { ApolloError } from 'apollo-client';

export const PartnerContext = createContext<{
  currentPartner?: PartnerType;
  loading: boolean;
  error?: ApolloError;
}>({
  loading: false,
});
